/**
 * Módulo compartilhado para máscaras e validações
 * Usado em diversos formulários do sistema
 */
class MasksValidator {
    constructor() {
        // Implementar singleton pattern
        if (MasksValidator.instance) {
            return MasksValidator.instance;
        }
        
        this.retryCount = 0;
        this.maxRetries = 10;
        this.initialized = false;
        
        MasksValidator.instance = this;
        this.init();
    }

    /**
     * Inicializar todas as máscaras
     */
    init() {
        if (this.initialized) {
            return;
        }
        
        this.setupMasks();
        this.initialized = true;
    }

    /**
     * Configurar máscaras de entrada
     */
    setupMasks() {
        $(document).ready(() => {
            // Verificar se o jQuery Mask Plugin está disponível
            if (typeof $.fn.mask === 'undefined') {
                this.retryCount++;
                
                if (this.retryCount > this.maxRetries) {
                    return;
                }
                
                setTimeout(() => {
                    this.setupMasks();
                }, 100);
                return;
            }
            
            // Reset do contador quando o plugin é encontrado
            this.retryCount = 0;
            
            // Máscara para valores monetários
            this.setupMoneyMasks();
            
            // Máscara para telefone
            this.setupPhoneMasks();
            
            // Máscara para CPF
            this.setupCpfMasks();
            
            // Máscara para CNPJ
            this.setupCnpjMasks();
            
            // Máscara para CEP
            this.setupCepMasks();
            
            // Máscara para placa de veículo
            this.setupPlateMasks();
            
            // Máscara para código de autenticação SMS
            this.setupAuthMasks();
        });
    }

    /**
     * Configurar máscaras monetárias
     */
    setupMoneyMasks() {
        // Verificar se o jQuery Mask Plugin está disponível
        if (typeof $.fn.mask === 'undefined') {
            return;
        }
        
        $('.valorMask, .money-mask, .currency-mask').mask('000.000.000.000.000,00', {
            reverse: true,
            placeholder: '0,00'
        });
    }

    /**
     * Configurar máscaras de telefone
     */
    setupPhoneMasks() {
        $('.phone-mask').mask('(00) 00000-0000', {
            placeholder: '(00) 00000-0000'
        });
        
        // Máscara para telefone celular
        $('.telCelMask, .celularMask').mask('(00) 00000-0000', {
            placeholder: '(00) 00000-0000'
        });
        
        // Máscara para telefone fixo
        $('.telMask, .telFixoMask').mask('(00) 0000-0000', {
            placeholder: '(00) 0000-0000'
        });
        
        // Máscara dinâmica para telefone (celular ou fixo)
        $('.phone-dynamic-mask').on('input', function() {
            const value = $(this).val().replace(/\D/g, '');
            if (value.length <= 10) {
                $(this).mask('(00) 0000-0000', {placeholder: '(00) 0000-0000'});
            } else {
                $(this).mask('(00) 00000-0000', {placeholder: '(00) 00000-0000'});
            }
        });
    }

    /**
     * Configurar máscaras de CPF
     */
    setupCpfMasks() {
        $('.cpf-mask, .cpfMask').mask('000.000.000-00', {
            placeholder: '000.000.000-00'
        });
    }

    /**
     * Configurar máscaras de CNPJ
     */
    setupCnpjMasks() {
        $('.cnpj-mask, .cnpjMask, .maskCNPJ').mask('00.000.000/0000-00', {
            placeholder: '00.000.000/0000-00'
        });
    }

    /**
     * Configurar máscaras de CEP
     */
    setupCepMasks() {
        $('.cep-mask, .cepMask').mask('00000-000', {
            placeholder: '00000-000'
        });
    }
    
    /**
     * Configurar máscaras de placa de veículo
     */
    setupPlateMasks() {
        // Aguardar o DOM estar completamente carregado
        $(document).ready(function() {
            const $plateField = $('#inputPlate, #modalInputPlate');
            
            if ($plateField.length === 0) {
                return;
            }
            
            // Remover qualquer atributo que possa estar bloqueando o campo
            $plateField.removeAttr('readonly')
                      .removeAttr('disabled')
                      .prop('disabled', false)
                      .prop('readonly', false)
                      .css('pointer-events', 'auto')
                      .css('user-select', 'auto');
            
            // Remover qualquer máscara existente
            if (typeof $plateField.unmask === 'function') {
                $plateField.unmask();
            }
            
            // Aplicar máscara simples que permite digitação
            if (typeof $.fn.mask === 'function' && typeof $plateField.mask === 'function') {
                $plateField.mask('AAA-0S00', {
                    placeholder: 'ABC-1D23',
                    translation: {
                        'A': {pattern: /[A-Za-z]/},
                        '0': {pattern: /[0-9]/},
                        'S': {pattern: /[A-Za-z0-9]/}
                    }
                });
            }
            
            // Converter para maiúsculo durante a digitação
            $plateField.on('input', function() {
                $(this).val($(this).val().toUpperCase());
            });
            
            // Validar placa contextualmente baseada no tipo de veículo
            $plateField.on('blur', function() {
                masksValidator.validatePlateByVehicleType();
            });
            
            // Aplicar máscara inicial
            $plateField.trigger('input');
            
            // Validar quando o tipo de veículo mudar
            $(document).on('click', '.vehicle-type-button, .modal-vehicle-type-button', function() {
                setTimeout(() => {
                    masksValidator.validatePlateByVehicleType();
                }, 100);
            });
          });
    }

    /**
     * Validar placa baseada no tipo de veículo selecionado
     */
    validatePlateByVehicleType() {
        const $plateField = $('#inputPlate, #modalInputPlate');
        if ($plateField.length === 0) return;
        
        const plateValue = $plateField.val().replace(/[^A-Z0-9]/g, '');
        if (plateValue.length < 7) return; // Só validar placas completas
        
        // Obter tipo de veículo selecionado
        let vehicleType = '';
        
        // Verificar diferentes contextos onde o tipo pode estar
        const activeButton = $('.vehicle-type-button.active, .modal-vehicle-type-button.active');
        if (activeButton.length > 0) {
            vehicleType = activeButton.data('tipo') || activeButton.attr('data-tipo');
        }
        
        // Fallback para campos hidden
        if (!vehicleType) {
            const hiddenField = $('#tipoVeiculo, #modalTipoVeiculo');
            if (hiddenField.length > 0) {
                vehicleType = hiddenField.val();
            }
        }
        
        if (!vehicleType) return; // Não validar se não conseguir determinar o tipo
        
        // Validar se a placa é compatível com o tipo de veículo
        const isValidForVehicleType = this.isPlateValidForVehicleType(plateValue, vehicleType);
        
        // Remover validações anteriores
        $plateField.removeClass('is-invalid is-valid');
        $plateField.siblings('.invalid-feedback').hide();
        $plateField.siblings('.plate-validation-feedback').remove();
        
        if (!isValidForVehicleType) {
            // Mostrar erro apenas se a placa não pertencer ao tipo de veículo
            $plateField.addClass('is-invalid');
            
            const errorMessage = this.getPlateValidationMessage(plateValue, vehicleType);
            $plateField.after(`<div class="invalid-feedback plate-validation-feedback" style="display: block;">${errorMessage}</div>`);
        } else {
            $plateField.addClass('is-valid');
        }
    }

    /**
     * Verificar se a placa é válida para o tipo de veículo
     */
    isPlateValidForVehicleType(plate, vehicleType) {
        // Regex para diferentes tipos de veículos
        const platePatterns = {
            'carros': /^[A-Z]{3}[0-9]{4}$|^[A-Z]{3}[0-9][A-Z][0-9]{2}$/, // Formato antigo e Mercosul
            'motos': /^[A-Z]{3}[0-9]{4}$/, // Apenas formato antigo para motos
            'caminhoes': /^[A-Z]{3}[0-9]{4}$/ // Apenas formato antigo para caminhões
        };
        
        const pattern = platePatterns[vehicleType];
        if (!pattern) return true; // Se não há padrão definido, considerar válido
        
        return pattern.test(plate);
    }

    /**
     * Obter mensagem de validação baseada no tipo de veículo
     */
    getPlateValidationMessage(plate, vehicleType) {
        const isMercosul = /^[A-Z]{3}[0-9][A-Z][0-9]{2}$/.test(plate);
        
        if (isMercosul && (vehicleType === 'motos' || vehicleType === 'caminhoes')) {
            const vehicleTypeName = vehicleType === 'motos' ? 'motos' : 'caminhões';
            return `Placas no padrão Mercosul (${plate.substring(0,3)}-${plate.substring(3,4)}${plate.substring(4,5)}${plate.substring(5,7)}) não são válidas para ${vehicleTypeName}. Use o formato antigo (ABC-1234).`;
        }
        
        return 'Formato de placa inválido para este tipo de veículo.';
    }

    /**
     * Configurar máscaras de código de autenticação SMS
     */
    setupAuthMasks() {
        $('.authMask').mask('000-000', {
            placeholder: '000-000'
        });
    }

    /**
     * Aplicar múltiplas máscaras baseadas em seletores
     * @param {Object} masks - Objeto com seletores como chave e tipos de máscara como valor
     */
    applyMasks(masks) {
        Object.entries(masks).forEach(([selector, maskType]) => {
            this.applyMask(selector, maskType);
        });
    }

    /**
     * Aplicar máscara específica a um elemento
     * @param {string|jQuery} element - Seletor ou elemento jQuery
     * @param {string} maskType - Tipo da máscara (money, phone, cpf, cnpj, cep)
     */
    applyMask(element, maskType) {
        // Verificar se o jQuery Mask Plugin está disponível
        if (typeof $.fn.mask === 'undefined') {
            return;
        }
        
        const $element = typeof element === 'string' ? $(element) : element;
        
        switch (maskType) {
            case 'money':
                $element.mask('000.000.000.000.000,00', {
                    reverse: true,
                    placeholder: '0,00'
                });
                break;
            case 'phone':
                $element.mask('(00) 00000-0000', {
                    placeholder: '(00) 00000-0000'
                });
                break;
            case 'cpf':
                $element.mask('000.000.000-00', {
                    placeholder: '000.000.000-00'
                });
                break;
            case 'cnpj':
                $element.mask('00.000.000/0000-00', {
                    placeholder: '00.000.000/0000-00'
                });
                break;
            case 'cep':
                $element.mask('00000-000', {
                    placeholder: '00000-000'
                });
                break;
            case 'cellphone':
                $element.mask('(00) 00000-0000', {
                    placeholder: '(00) 00000-0000'
                });
                break;
            case 'percent':
                $element.mask('##0,00%', {
                    reverse: true,
                    placeholder: '0,00%'
                });
                break;
            case 'plate':
                // Máscara dinâmica para placa (antigo e Mercosul)
                const plateValue = $element.val().toUpperCase().replace(/[^A-Z0-9]/g, '');
                
                if (plateValue.length >= 5 && /^[A-Z]{3}[0-9][A-Z]/.test(plateValue)) {
                    // Formato Mercosul: ABC1D23
                    $element.mask('AAA0A00', {
                        placeholder: 'ABC1D23',
                        translation: {
                            'A': {pattern: /[A-Za-z]/},
                            '0': {pattern: /[0-9]/}
                        }
                    });
                } else {
                    // Formato antigo: ABC1234
                    $element.mask('AAA0000', {
                        placeholder: 'ABC1234',
                        translation: {
                            'A': {pattern: /[A-Za-z]/},
                            '0': {pattern: /[0-9]/}
                        }
                    });
                }
                break;
            case 'year':
                $element.mask('0000', {
                    placeholder: 'AAAA'
                });
                break;
            case 'number':
                $element.mask('000000000000', {
                    placeholder: '0'
                });
                break;
            default:
        }
    }

    /**
     * Validar CPF
     * @param {string} cpf - CPF para validar
     * @returns {boolean} True se válido
     */
    validateCpf(cpf) {
        cpf = cpf.replace(/[^\d]/g, '');
        
        if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) {
            return false;
        }
        
        let sum = 0;
        for (let i = 0; i < 9; i++) {
            sum += parseInt(cpf.charAt(i)) * (10 - i);
        }
        
        let remainder = 11 - (sum % 11);
        if (remainder === 10 || remainder === 11) remainder = 0;
        if (remainder !== parseInt(cpf.charAt(9))) return false;
        
        sum = 0;
        for (let i = 0; i < 10; i++) {
            sum += parseInt(cpf.charAt(i)) * (11 - i);
        }
        
        remainder = 11 - (sum % 11);
        if (remainder === 10 || remainder === 11) remainder = 0;
        
        return remainder === parseInt(cpf.charAt(10));
    }

    /**
     * Validar CNPJ
     * @param {string} cnpj - CNPJ para validar
     * @returns {boolean} True se válido
     */
    validateCnpj(cnpj) {
        cnpj = cnpj.replace(/[^\d]/g, '');
        
        if (cnpj.length !== 14) return false;
        
        // Eliminar CNPJs conhecidos como inválidos
        if (/^(\d)\1{13}$/.test(cnpj)) return false;
        
        // Validar DVs
        let length = cnpj.length - 2;
        let numbers = cnpj.substring(0, length);
        let digits = cnpj.substring(length);
        let sum = 0;
        let pos = length - 7;
        
        for (let i = length; i >= 1; i--) {
            sum += numbers.charAt(length - i) * pos--;
            if (pos < 2) pos = 9;
        }
        
        let result = sum % 11 < 2 ? 0 : 11 - sum % 11;
        if (result !== parseInt(digits.charAt(0))) return false;
        
        length = length + 1;
        numbers = cnpj.substring(0, length);
        sum = 0;
        pos = length - 7;
        
        for (let i = length; i >= 1; i--) {
            sum += numbers.charAt(length - i) * pos--;
            if (pos < 2) pos = 9;
        }
        
        result = sum % 11 < 2 ? 0 : 11 - sum % 11;
        
        return result === parseInt(digits.charAt(1));
    }

    /**
     * Validar email
     * @param {string} email - Email para validar
     * @returns {boolean} True se válido
     */
    validateEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    }

    /**
     * Validar telefone
     * @param {string} phone - Telefone para validar
     * @returns {boolean} True se válido
     */
    validatePhone(phone) {
        const cleanPhone = phone.replace(/\D/g, '');
        return cleanPhone.length >= 10 && cleanPhone.length <= 11;
    }

    /**
     * Formatar valor monetário
     * @param {number|string} value - Valor para formatar
     * @returns {string} Valor formatado
     */
    formatMoney(value) {
        const numericValue = typeof value === 'string' ? 
            parseFloat(value.replace(/[^\d,-]/g, '').replace(',', '.')) : value;
        
        if (isNaN(numericValue)) return '0,00';
        
        return numericValue.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    /**
     * Converter valor monetário para número
     * @param {string} moneyString - String monetária (ex: "1.234,56")
     * @returns {number} Valor numérico
     */
    parseMoney(moneyString) {
        if (!moneyString) return 0;
        
        const cleanValue = moneyString.toString()
            .replace(/[^\d,-]/g, '')
            .replace(/\./g, '')
            .replace(',', '.');
            
        return parseFloat(cleanValue) || 0;
    }

    /**
     * Configurar validação em tempo real para um formulário
     * @param {string|jQuery} form - Seletor ou elemento jQuery do formulário
     */
    setupRealTimeValidation(form) {
        const $form = typeof form === 'string' ? $(form) : form;
        const self = this;
        
        $form.find('.cpf-mask').on('blur', function() {
            const $this = $(this);
            const cpf = $this.val();
            
            if (cpf && !self.validateCpf(cpf)) {
                $this.addClass('is-invalid');
                $this.siblings('.invalid-feedback').text('CPF inválido');
            } else {
                $this.removeClass('is-invalid');
            }
        });
        
        $form.find('.cnpj-mask').on('blur', function() {
            const $this = $(this);
            const cnpj = $this.val();
            
            if (cnpj && !self.validateCnpj(cnpj)) {
                $this.addClass('is-invalid');
                $this.siblings('.invalid-feedback').text('CNPJ inválido');
            } else {
                $this.removeClass('is-invalid');
            }
        });
        
        $form.find('input[type="email"]').on('blur', function() {
            const $this = $(this);
            const email = $this.val();
            
            if (email && !self.validateEmail(email)) {
                $this.addClass('is-invalid');
                $this.siblings('.invalid-feedback').text('Email inválido');
            } else {
                $this.removeClass('is-invalid');
            }
        });
    }

    /**
     * Remover todas as máscaras de um elemento
     * @param {string|jQuery} element - Seletor ou elemento jQuery
     */
    removeMask(element) {
        const $element = typeof element === 'string' ? $(element) : element;
        $element.unmask();
    }

    /**
     * Reconfigurar máscaras (útil para conteúdo dinâmico)
     */
    refresh() {
        this.setupMasks();
    }
}

window.MasksValidator = window.MasksValidator || MasksValidator;
window.masksValidator = window.masksValidator || new MasksValidator();

// Instância global única
let masksValidatorInstance = null;

// Exportar a classe e uma função para obter a instância única
export { MasksValidator };

/**
 * Função para obter a instância única do MasksValidator
 * @returns {MasksValidator} Instância única do MasksValidator
 */
export function getMasksValidator() {
    if (!masksValidatorInstance) {
        masksValidatorInstance = new MasksValidator();
    }
    return masksValidatorInstance;
}

// Instanciar globalmente para compatibilidade
window.masksValidator = getMasksValidator();
